import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ICountry, ICustomerData } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private http: HttpClient) {
  }

  getCustomerData(): Observable<ICustomerData> {
    return this.http.get<ICustomerData>('/api/customers/current')
      .pipe(
        map((customerData: ICustomerData) => {
          customerData = {
            ...customerData,
            mobileNumber: this.separateMobileNumberAndCountryPhoneCode(customerData.mobileNumber, customerData.country)
          };
          return customerData;
        }));
  }

  private separateMobileNumberAndCountryPhoneCode(mobileNumber: string, country: ICountry): string {
    return mobileNumber.replace(country.phoneCode, '');
  }

}
